import { SortRule } from "app/containers/Features/components/SortingControl/types";
import {
  BoardPermission,
  BoardType,
  BoardViewType,
  ICustomizeColumns
} from "app/types";
import { TicketGroup } from "../../containers/Tickets/types";
import { GroupByTypeEnum } from "../../types";
export interface IMoreDetails {
  owner: string;
  createdAt: string;
  description: string;
}
export interface IBoardFilterValues {
  status: string[];
  ticketType: string[];
  dueDate: string[];
  priority: string[];
  tags: string[];
  release: string[];
  targetRelease: string[];
  sprint: string[];
  environment: string[];
  severity: string[];
  component: string[];
  assignee: string[];
  creator: string[];
  createdDate: string[];
}
export interface IBoardsFilters {
  search: string;
  sort: SortRule[];
  filters: IBoardFilterValues | null;
  appliedFilterIds: string[];
}
export interface IBoardState {
  _id: string;
  name: string;
  description: string;
  viewType: BoardViewType;
  Type: BoardType;
  moreDetails: IMoreDetails;
  groupBy: GroupByTypeEnum;
  visibleGroups: TicketGroup[];
  subGroupBy: GroupByTypeEnum;
  customizeCards: ICustomizeColumns[];
  permission: BoardPermission;
  permissionUser: [];
  defaultTicketValues: Record<
    string,
    string | Date | string[] | boolean | number | []
  >[];
  defaultTicketType: string;
  groups: IGroup[];
  groupJson: string | null;
  filters: IBoardsFilters;
}

export interface IGroup {
  _id: string;
  title: string;
  order: number;
  tickets: ITicketGroup[];
}

interface ITicketGroup {
  _id: string;
  ticketId: string;
  order: number;
}

export interface IExportSettings {
  format: ExportFormatEnum;
  whatToExport: WhatToExportEnum;
  dateFormat: DateFormatEnum;
  timeFormat: TimeFormatEnum;
}

export interface ExportBoardAction {
  id: string;
  fileFormat: string;
  exportScope: string;
  dateFormat: string;
  timeFormat: string;
  callback?: (data: Blob) => void;
}

export enum ExportFormatEnum {
  CSV = "csv",
  EXCEL = "excel",
}

export enum WhatToExportEnum {
  VISIBLE_COLUMNS = "visible_columns",
  TICKETS_NAMES_ONLY = "ticket_names_only",
  ALL_COLUMNS = "all_columns",
}

export enum DateFormatEnum {
  NORMAL = "normal",
  ISO = "iso",
  POSIX = "posix",
}

export enum TimeFormatEnum {
  NORMAL = "normal",
  HH_MM = "hh:mm",
  HH_MM_SS = "hh:mm:ss",
}
export interface IMultipleShorting {
  fields: { key: string; label: string }[];
  expanded: boolean;
  draggedIndex: number | null;
}

export interface BoardSettingState {
  isBoardCreate: boolean;
  isBoardLoading: boolean;
  isBoardUpdate: boolean;
  boardForm: IBoardState;
  draftBoardForm: IBoardState;
  ticketDropdownSearchKeyword: string;
  isShownBoardSetting: boolean;
  isExportingBoard: boolean;
  exportSettings: IExportSettings;
  boardDraftFormModal: boolean;
  boardsShorting: IMultipleShorting;
}
